import React from 'react'
import HeroSession from './HeroSession/HeroSession'
import AboutSession from './AboutSession/AboutSession'
import ServicesSession from './ServicesSession/ServicesSession'
import WhychooseusSession from './WhyChooseusSession/WhychooseusSession'
import LeavecargoSession from './LeavecargoSession/LeavecargoSession'

function Home() {
  return (
    <div>
    <div className="home-container">
      <HeroSession/>
    </div>
    <div className="home-about">
      <AboutSession/>
    </div>
     <div className="home-services">
      <ServicesSession/>
    </div>
     <div className="home-whychooseus">
      <WhychooseusSession/>
    </div>
      <div className="home-leavecargo">
      <LeavecargoSession/>
    </div>
    </div>
  )
}

export default Home
